module.exports = __webpack_public_path__ + "img/teaser.5940017d.png";